/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { router } from "@/providers/RouterProvider";
import { toast } from "sonner";
// Utils
import { ApiError } from "@/helpers/api.helper";

// Store
import usePhysiomKineStore from "@/stores/physiomKine";
// Configs
import { i18next } from "@/i18n/i18n";

/* -------------------------------------------------------------------------- */
/*                                Helper Function                            */
/* -------------------------------------------------------------------------- */

export default async function globalErrorHandler(error: unknown) {
  if (error instanceof ApiError) {
    const { isAuthenticated, logout } = usePhysiomKineStore.getState();

    if (
      error.status === 401 ||
      (error.status === 403 &&
        error.route !== "auth/signin" &&
        error.route !== "auth/signout")
    ) {
      toast.error(i18next.t("api_errors.unauthorized_access"));
      if (isAuthenticated) {
        logout();
        router.navigate({ to: "/auth/login" });
      }
      return;
    }

    if (error.status === 500) {
      toast.error(i18next.t("api_errors.an_error_occured"));
      return;
    }
  }
}
